export const APP_MESSAGES = {
    // User Management
    CREATE_USER_SUCCESS: 'User has been successfully created',
    UPDATE_USER_SUCCESS: 'User has been successfully updated',
    DELETE_USER_SUCCESS: 'User has been successfully deleted',

    CREATE_CUSTOMER_SUCCESS: 'Customer has been successfully created',
    UPDATE_CUSTOMER_SUCCESS: 'Customer has been successfully updated',
    DELETE_CUSTOMER_SUCCESS: 'Customer has been successfully deleted',

    UPDATE_USER_STATUS_SUCCESS: 'User status has been successfully updated',
    UPDATE_USER_READ_ONLY_STATUS_SUCCESS: 'User read-only status has been successfully updated',

    UPDATE_CUSTOMER_READ_ONLY_STATUS_SUCCESS: 'Customer read-only status has been successfully updated',
    UPDATE_CUSTOMER_DEFAULT_SUCCESS: 'Default Customer has been successfully updated',

    // TODO: Refactor double Ds xD
    CREATE_PRODDUCT_CATEGORY_SUCCESS: 'Product Category has been successfully created',
    UPDATE_PRODDUCT_CATEGORY_SUCCESS: 'Product Category has been successfully updated',
    DELETE_PRODDUCT_CATEGORY_SUCCESS: 'Product Category has been successfully deleted',

    CREATE_PRODDUCT_ATTRIBUTE_SUCCESS: 'Product Attribute has been successfully created',
    UPDATE_PRODDUCT_ATTRIBUTE_SUCCESS: 'Product Attribute has been successfully updated',
    DELETE_PRODDUCT_ATTRIBUTE_SUCCESS: 'Product Attribute has been successfully deleted',

    // Product CRUD
    CREATE_PRODUCT_SUCCESS: 'Product has been successfully created',
    UPDATE_PRODUCT_STATUS_SUCCESS: 'Product status has been successfully updated',
    UPDATE_PRODUCT_ATTRIBUTE_VALUE_SUCCESS: 'Product attribute has been successfully updated',

    UPDATE_PRODUCT_CATEGORY_SELECT_SUCCESS: 'Product category has been successfully updated',

    UPDATE_PRODUCT_CREATE_DEFAULT_PRICING_SUCCESS: 'Product default pricing has been successfully created',
    UPDATE_PRODUCT_UPDATE_DEFAULT_PRICING_SUCCESS: 'Product default pricing has been successfully updated',
    UPDATE_PRODUCT_DELETE_DEFAULT_PRICING_SUCCESS: 'Product default pricing has been successfully deleted',

    UPDATE_PRODUCT_CREATE_CUSTOMER_PRICING_SUCCESS: 'Product customer pricing has been successfully created',
    UPDATE_PRODUCT_UPDATE_CUSTOMER_PRICING_SUCCESS: 'Product customer pricing has been successfully updated',
    UPDATE_PRODUCT_DELETE_CUSTOMER_PRICING_SUCCESS: 'Product customer pricing has been successfully deleted',

    UPDATE_PRODUCT_CREATE_MEDIA_SUCCESS: 'Product media has been successfully created',
    UPDATE_PRODUCT_UPDATE_MEDIA_SUCCESS: 'Product media has been successfully updated',
    UPDATE_PRODUCT_DELETE_MEDIA_SUCCESS: 'Product media has been successfully deleted',

    UPDATE_PRODUCT_CREATE_ATTACHMENT_SUCCESS: 'Product attachment has been successfully created',
    UPDATE_PRODUCT_UPDATE_ATTACHMENT_SUCCESS: 'Product attachment has been successfully updated',
    UPDATE_PRODUCT_DELETE_ATTACHMENT_SUCCESS: 'Product attachment has been successfully deleted',

    // Customer Addresses
    UPDATE_CUSTOMER_BILLING_SUCCESS: 'Customer billing address has been successfully updated',
    UPDATE_CUSTOMER_SHIPPING_SUCCESS: 'Customer shipping address has been successfully updated',

    //Invoice Payment Upload
    UPLOAD_CUSTOMER_INVOICE_PAYMENT_SUCCESS: 'Customer invoice payment has been successfully updated',

    CREATE_LABELS_SUCCESS: 'Processing Labels'
}

export const ERR_MESSAGES = {
    GENERIC: $localize`:@@errorMsgGeneric:An error has occurred: `,
    LOGIN_WRONG_CREDENTIALS: 'Invalid username and/or password',
    INVALID_FILE_TYPE: 'Invalid file type',
    SESSION_EXPIRED: 'Your session has expired. Please login again to continue',
    INTERNAL_SERVER_ERROR: 'Server error, please try again later',
    FORM_FIELDS_ERROR: $localize`:@@errorMsgFormFields:There are errors in some fields. Please correct them and try again.`,
    INVALID_FORMAT_CONTACT_NUMBER: $localize`:@@errorMsgInvalidFormatContactNumber:Enter a 10-digit Canadian phone number (e.g., 416-555-1234)`,
    INVALID_FORMAT_EMAIL: $localize`:@@errorMsgInvalidFormatEmail:Enter an email address in the format name@example.com`
}
